<template>
  <div
    :class="[
      'flex items-center gap-4 px-2 py-1.5 rounded-xl',
      statusClasses.bg,
    ]"
  >
    <div class="w-bulk-import-error-line shrink-0 flex items-center gap-2">
      <component
        :is="statusClasses.icon"
        :class="['w-5 h-5 flex-shrink-0', statusClasses.iconColor]"
        aria-hidden="true"
      />
      <span class="text-label-xs font-bold text-red-950">
        {{ t('corp.bulk_import.validation_error.line', { line }) }}
      </span>
    </div>

    <span :class="['text-label-xs min-w-0 flex-1', statusClasses.messageColor]">
      {{ message }}
    </span>

    <span v-if="field" class="text-label-xs shrink-0 text-grey-600">
      {{ t('corp.bulk_import.validation_error.field_column') }}: {{ field }}
    </span>

    <span v-if="value" class="text-label-xs shrink-0 text-grey-600">
      {{ t('corp.bulk_import.validation_error.value_column') }}: {{ value }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import { useI18n } from 'vue-i18n'
import { BlockWarningIcon, CopyIcon } from '@ecx/ui/icons'
import type { BulkImportErrorStatus } from '@/types/bulkImport'

const props = defineProps<{
  line: number
  status: BulkImportErrorStatus
  message: string
  field?: string
  value?: string
}>()

const { t } = useI18n()

const STATUS_CLASSES: Record<
  BulkImportErrorStatus,
  { bg: string; icon: Component; iconColor: string; messageColor: string }
> = {
  error: {
    bg: 'bg-red-25',
    icon: BlockWarningIcon,
    iconColor: '',
    messageColor: 'text-red-900',
  },
  warning: {
    bg: 'bg-grey-50',
    icon: CopyIcon,
    iconColor: 'text-grey-800',
    messageColor: 'text-grey-800',
  },
  ignored: {
    bg: 'bg-grey-50',
    icon: CopyIcon,
    iconColor: 'text-grey-800',
    messageColor: 'text-grey-800',
  },
}

const statusClasses = computed(() => STATUS_CLASSES[props.status])
</script>
